module.exports = __webpack_public_path__ + "img/Houdini-water-chamber.9240e31.jpeg";